import {FullGameFetchHandler} from "../../../core/handlers/full-game.fetch-handler";
import {PREDICTION_WIDGET} from "../predictions-widget.consts";

export class PredictionsWidgetFetchHandler extends FullGameFetchHandler {
  async action() {
    const dataSource = await this.fetch(this.createDomainParams(), !!this.state.dataSource);

    await this.controller.action(PREDICTION_WIDGET.ACTION_TYPES.populateData, {dataSource});
    await this.controller.props?.onWidgetVisible(this.state.isPopulated);

    return new Promise(resolve => {
      setTimeout(() => resolve(""), 5000);
    });
  }
}
